module.exports = __webpack_public_path__ + "static/media/barcode-read.bd233125.svg";